module.exports = __webpack_public_path__ + "media/bootstrap-icons/vinyl-fill-6e1b1d39.svg";